var _circle, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36,
    cy: 36,
    r: 35.5,
    fill: "#F8B326",
    fillOpacity: 0.03,
    stroke: "#F8B326",
    strokeDasharray: "2 2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42.5 23H29.5C25.9101 23 23 25.9101 23 29.5V42.5C23 46.0898 25.9101 49 29.5 49H42.5C46.0898 49 49 46.0898 49 42.5V29.5C49 25.9101 46.0898 23 42.5 23Z",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2 35.1811C41.3605 36.2631 41.1757 37.368 40.6719 38.3389C40.1682 39.3097 39.3711 40.097 38.3941 40.5887C37.4172 41.0805 36.31 41.2516 35.2301 41.0779C34.1503 40.9041 33.1527 40.3943 32.3793 39.6209C31.6059 38.8475 31.0961 37.8499 30.9223 36.77C30.7485 35.6902 30.9197 34.583 31.4114 33.606C31.9032 32.6291 32.6905 31.832 33.6613 31.3283C34.6321 30.8245 35.7371 30.6397 36.819 30.8001C37.9226 30.9638 38.9443 31.4781 39.7332 32.2669C40.5221 33.0558 41.0364 34.0775 41.2 35.1811Z",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43.15 28.8501H43.163",
    stroke: "#F8B326",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsta);
export default __webpack_public_path__ + "static/media/insta.5079aca58b200959059beeb0b5eacc30.svg";
export { ForwardRef as ReactComponent };